//@flow
import api from 'api';

async function errorLogger({ name, log }) {
  try {
    api.postErrorLog({ name, log });
  } catch (error) {}
}

export default errorLogger;
